export const MULTI_WALLET_UPGRADE_MODAL = 'multi-wallet-upgrade-modal';
